import { type FC, useState } from "react";
import { ProductTabularViewActionCell } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/ProductTabularViewActionCell";
import { LinkButton } from "~/common/components/Link";
import { type TabularViewData } from "~/features/search/models/models";
import { type Row } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { VariantProductsTableModal } from "~/features/selectionAssistant/housing/components/VariantProductsTableModal/VariantProductsTableModal";
import { PurchasePlaceProvider, PurchaseTypeProvider } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import { ProductTabularViewModalProvider } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/ProductTabularViewModalContext";

interface Props {
  row: Row<TabularViewData>;
}

export const HousingProductTabularViewActionCell: FC<Props> = ({ row }: Props) => {
  const { product, variantProducts } = row.original;
  const { t } = useTranslation();
  const isExpandActionCell = variantProducts.length > 0;
  const [isOpen, setIsOpen] = useState(false);

  if (isExpandActionCell) {
    return (
      <div className={"d-flex flex-justify-center"}>
        <LinkButton
          data-test-id={"tabular-view-action-button-expand-details"}
          onClick={() => {
            setIsOpen(true);
          }}
          type={"button"}
        >
          {t("page.sa.housing.seemore")}
        </LinkButton>
        {isOpen && (
          <PurchasePlaceProvider value={"HSA"}>
            <PurchaseTypeProvider value={"hsa"}>
              <ProductTabularViewModalProvider value={{ close: () => setIsOpen(false), open: () => setIsOpen(true) }}>
                <VariantProductsTableModal onClose={() => setIsOpen(false)} products={variantProducts} />
              </ProductTabularViewModalProvider>
            </PurchaseTypeProvider>
          </PurchasePlaceProvider>
        )}
      </div>
    );
  }

  return <ProductTabularViewActionCell productCode={product.code} isHousing={true} />;
};
